import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  COOKIE_SETTINGS_EVENT,
  denyAnalyticsConsent,
  getAnalyticsConsent,
  grantAnalyticsConsent,
  trackPageView,
} from "../lib/analytics";

export function CookieConsent() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(() => getAnalyticsConsent() === null);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(COOKIE_SETTINGS_EVENT, show);
    return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, show);
  }, []);

  if (!open) return null;

  const accept = () => {
    grantAnalyticsConsent()
      .then(() => trackPageView(`${window.location.pathname}${window.location.search}`))
      .catch(() => {});
    setOpen(false);
  };
  const reject = () => {
    denyAnalyticsConsent();
    setOpen(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[100] p-4 sm:p-6" role="dialog" aria-modal="true" aria-label={t("cookieConsent.title")} data-testid="cookie-consent">
      <div className="mx-auto max-w-3xl rounded-xl border border-border bg-card p-5 shadow-2xl sm:p-6">
        <h2 className="text-lg font-semibold text-foreground">{t("cookieConsent.title")}</h2>
        <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{t("cookieConsent.body")}</p>
        <p className="mt-2 text-xs text-muted-foreground">
          <Link className="underline underline-offset-4 hover:text-foreground" to="/legal/cookies">{t("cookieConsent.learnMore")}</Link>
        </p>
        <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button type="button" onClick={reject} className="rounded-md border border-border px-4 py-2 text-sm font-medium text-foreground hover:bg-muted" data-testid="reject-analytics">
            {t("cookieConsent.reject")}
          </button>
          <button type="button" onClick={accept} className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90" data-testid="accept-analytics">
            {t("cookieConsent.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
